import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as JSON$dPath from "../JSON.Path/index.js";
const DecodeError = x => x;
const showDecodeError = {
  show: v => "(DecodeError { causes: " + Data$dShow.showArrayImpl(showDecodeError.show)(v.causes) + ", message: " + Data$dShow.showStringImpl(v.message) + ", path: " + JSON$dPath.showPath.show(v.path) + " })"
};
const semigroupDecodeError = {
  append: v => v1 => (
    {
      path: JSON$dPath.findCommonPrefix(v.path)(v1.path),
      message: "Failed to decode alternatives",
      causes: [...v.message === "Failed to decode alternatives" ? v.causes : [v], ...v1.message === "Failed to decode alternatives" ? v1.causes : [v1]]
    }
  )
};
const newtypeDecodeError_ = {Coercible0: () => {}};
const genericDecodeError_ = {to: x => x, from: x => x};
const eqDecodeError = {eq: x => y => Data$dEq.eqArrayImpl(eqDecodeError.eq)(x.causes)(y.causes) && x.message === y.message && JSON$dPath.eqPath.eq(x.path)(y.path)};
const ordDecodeError = {
  compare: x => y => {
    const v = Data$dOrd.ordArray(ordDecodeError).compare(x.causes)(y.causes);
    if (v === "LT") { return Data$dOrdering.LT; }
    if (v === "GT") { return Data$dOrdering.GT; }
    const v1 = Data$dOrd.ordString.compare(x.message)(y.message);
    if (v1 === "LT") { return Data$dOrdering.LT; }
    if (v1 === "GT") { return Data$dOrdering.GT; }
    return JSON$dPath.ordPath.compare(x.path)(y.path);
  },
  Eq0: () => eqDecodeError
};
const withPath = f => err => ({...err, path: f(err.path), causes: Data$dFunctor.arrayMap(withPath(f))(err.causes)});
const withContext = message => err => ({path: err.path, message, causes: [err]});
const print = v => {
  const causes = Data$dFunctor.arrayMap(e => Data$dString$dCommon.replaceAll("\n")(v.causes.length === 1 ? "\n  " : "\n    ")(print(withPath(p => {
    const $0 = JSON$dPath.stripPrefix(v.path)(p);
    if ($0.tag === "Nothing") { return p; }
    if ($0.tag === "Just") { return $0._1; }
    $runtime.fail();
  })(e))))(v.causes);
  const v1 = v.causes.length;
  return (JSON$dPath.eqPath.eq(v.path)(JSON$dPath.Tip) ? "" + v.message : JSON$dPath.print(v.path) + ": " + v.message) + (() => {
    if (v1 === 0) { return ""; }
    if (v1 === 1) { return ":\n  " + Data$dString$dCommon.joinWith("\n  ")(causes); }
    return ":\n  - " + Data$dString$dCommon.joinWith("\n  - ")(causes);
  })();
};
const error = path => message => ({path, message, causes: []});
const noValueFound = path => ({path, message: "No value found", causes: []});
const basic = message => ({path: JSON$dPath.Tip, message, causes: []});
export {
  DecodeError,
  basic,
  eqDecodeError,
  error,
  genericDecodeError_,
  newtypeDecodeError_,
  noValueFound,
  ordDecodeError,
  print,
  semigroupDecodeError,
  showDecodeError,
  withContext,
  withPath
};
